import { delayedCall, dispatcher,ingenuity } from "@quest/base-core";
import { FreeGameWinPresentationControllerBehavior,SlotEventConstantsBehavior } from "@quest/murka-games-behavior-leopard/dist"
import { SlotEventConstants } from "@quest/slot-core";
import { eventDispatchers } from "../Constants/EventDispatchers";
import { GameParserModel } from "../Platform/GameParserModel";
export class FreeGameWinPresentationControllerGame extends FreeGameWinPresentationControllerBehavior {
    /*
    to handle stack animations onn all frames
    */
    protected onShowAllFrames(): void {
        if((ingenuity.parserModel as GameParserModel).getIsStickyWildAvailable()){
            dispatcher.fireEvent(eventDispatchers.PLAY_WILD_WIN_ANIM)
        }
        const windata = ingenuity.configData.waysGame ? this.model.getWaysWinAllUniquePositions() : this.model.getWinLinesData();
        if (this.paylineView) {
            dispatcher.fireEvent(SlotEventConstants.FG_SHOW_ALL_FRAMES, {
                callback() {
                    if ((this.model.getIsBigWin())) {
                        dispatcher.fireEvent(SlotEventConstants.FG_SHOW_NEXT_WIN_PRESENTATION);
                    }
                },
                callbackScope: this,
                delayTimer: this.model.getDelayForSpaghttiDispaly(),
                winData: windata
            });
        } else {
            dispatcher.fireEvent(SlotEventConstants.FG_SHOW_NEXT_WIN_PRESENTATION);
        }
        // Play all anim with delay to show stack before static hide.
        if ((ingenuity.parserModel as GameParserModel).getStackSymPresentFG() && (ingenuity.parserModel as GameParserModel).getCommonOffsetsOfStackAndWin().length > 0) {
            delayedCall("playAnimDelayForStack", 100, () => {
                dispatcher.fireEvent(SlotEventConstantsBehavior.PLAY_ALL_SYMBOL_ANIM);
            }, this)
        } else {
            dispatcher.fireEvent(SlotEventConstantsBehavior.PLAY_ALL_SYMBOL_ANIM);
        }
    }
    /**overrided to stop feature animations */
    protected onSuspendWinPresentation(): void {
        super.onSuspendWinPresentation();
        dispatcher.fireEvent(eventDispatchers.SUPSPEPND_WILD_WIN);
        dispatcher.fireEvent(eventDispatchers.HIDE_LARGE_STACK_SYMBOL_FG);
        dispatcher.fireEvent(eventDispatchers.SET_STACK_SPINE_PAUSE, true)
    }

}

